import { Tag } from "../Tags.ts"
import { TextField, Box, Button, Autocomplete, Grid } from "@mui/material";

interface Props { 
  tags: Tag[], 
  addTag: any, removeTag: any
}
export const EventArtistSearch = ({ tags, addTag, removeTag } : Props) => {
    return <Autocomplete fullWidth
        noOptionsText="No tags found" options={Object.values(Tag)} 
        onChange={(_, tag) => {
            if(tag){ addTag(tag); }
        }}
        renderInput={(params) => (
            <div>
                <TextField {...params} label="Event Tags" fullWidth />
                { tags.length > 0 && 
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center',
                        gap: '10px', padding: '10px 0' 
                    }}>
                        {tags.map((t) => {
                            return <Button sx={{ textTransform: 'none' }}
                                onClick={() => { removeTag(t); }}
                                variant="outlined"
                            >{t}</Button>
                        })}
                    </div>
                }
            </div>
        )}
        renderOption={({ key, ...props }, tag) => ( !tags.includes(tag) &&
            <li key={key} {...props}>
                <Grid sx={{ width: '100%', wordWrap: 'break-word' }}>
                    <Box component="span" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <div>{tag}</div>
                    </Box>
                </Grid>
            </li>
        )}
    />
};
export default EventArtistSearch;